module.exports = __webpack_public_path__ + "0cf76bd774f8b558f47f576e93327f39.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/counter-icons/08_icon_data.gif
// module id = 681
// module chunks = 0